import merge from 'lodash/merge'

import { useBuilder } from '@/lib/builder/extension/useBuilder'

import type { LocationSelectSection } from '../../../../types/FormBuilder.types'

const formBuilderQueue = useBuilder('formBuilder')

const LocationSelectCommands = {
  updateBlock: formBuilderQueue.createBlockCommand<LocationSelectSection>({
    commit: async (currentData, ctx) => {
      return merge(currentData, ctx.update)
    },
  }),
}

export { LocationSelectCommands }
